import '../assets/css/bookingListContainer.less';
// react
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Modal } from 'antd';
import { parseUrl } from './../utils';
import { ifRestrict } from './../utils/verify';

/**
 * @description 预约列表组件
 * @param {*} props
 * @returns {*} booking list container
 */
const BookingListContainer = (props) => {
    const { evaluationReportId, saas_id, chapterId, sectionId, projectId, teamType, sourcesType, sourcesId } = parseUrl();
    const editUrlAddNeed = (url) => {
        let resUrl = url;
        // 新类型拼接参数
        if (projectId) {
            resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}projectId=${projectId}`;
        }
        if (teamType) {
            resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}teamType=${teamType}`;
        }
        if (sourcesType) {
            resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}sourcesType=${sourcesType}`;
        }
        if (sourcesId) {
            resUrl += `${resUrl.indexOf('?') === -1 ? '?' : '&'}sourcesId=${sourcesId}`;
        }
        return resUrl;
    };

    /**
     * @description 收费弹窗
     * @param {*} url
     */
    const costModal = (url) => {
        if (url) {
            Modal.confirm({
                title: '抱歉，您还暂无此项目私教服务',
                content: '是否前往购买此项目的私教服务？',
                onOk() {
                    window.location.href = url;
                },
                okText: '去购买',
                cancelText: '取消',
            });
        } else {
            Modal.error({
                title: '抱歉，您还暂无此项目私教服务',
                content: '需购买此项目的私教服务才可以享受私教服务',
                okText: '关闭',
            });
        }
    };

    /**
     * @description 路由跳转
     * @param {*} item 
     * @param {*} type 
     */
    const handleRouterBooking = async (item, type) => {
        // 如果是我的服务列表则直接跳转
        let result = await ifRestrict(item.serviceTeamId);
        if (result !== 0) {
            return;
        }
        if (type === 'my') {
            if (sessionStorage.getItem('successInfo')) {
                sessionStorage.removeItem('successInfo');
            }
            if (evaluationReportId) {
                props.history.push(editUrlAddNeed(`/tutor/booking/${item.serviceTeamId}?service_name=${item.serviceTeamName}&evaluationReportId=${evaluationReportId}&saas_id=${saas_id}&is_back=1&sectionId=${sectionId}&chapterId=${chapterId}`));
                return;
            }
            props.history.push(editUrlAddNeed(`/tutor/booking/${item.serviceTeamId}?service_name=${item.serviceTeamName}&is_back=1`));
            return;
        }
        costModal(item.url);
    };

    /**
     * @description 列表容器
     */
    const BookingListWrapper = (
        <ul className="booking-list-row">
            {
                props.bookingList.map((item, key) => (
                    <li
                        className="booking-list-item"
                        key={key}
                        onClick={() => { handleRouterBooking(item, props.type); }}
                    >
                        <div className="list-item-title">{item.serviceTeamName}</div>
                        <div className="list-item-desc">{item.teamDesc}</div>
                        <div className="list-item-bg">{item.projectName}</div>
                    </li>
                ))
            }
        </ul>
    );

    return (
        <div className="booking-list-container">
            {/* 标题 */}
            <div className="booking-list-type-title">
                {props.title}
                <div className="border" />
            </div>
            {/* 内容 */}
            {props.bookingList && BookingListWrapper}
        </div>
    );
};

export default withRouter(BookingListContainer);